<template>
  <div class="va">
    <TopHead
      name="视频赏析"
      :is-f5="true"
    />
    <!--    <div class="va_tab d_f ali_c">
      <div class="tab ac">景区</div>
      <div class="tab">活动</div>
    </div>-->

    <!--列表-->
    <van-pull-refresh
      v-model="loading"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :immediate-check="false"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          v-for="(item,index) in list"
          :key="index"
          class="list_item_va cur_p"
          @click="$router.push('/vaInner?id='+item.videoId)"
        >
          <van-image
            fit="cover"
            :src="item.coverUrl"
          >
            <template #loading>
              <img
                src="../assets/img/img_loading.png"
                alt=""
              >
            </template>
          </van-image>
          <div class="li_con d_f ali_c j_s over_h">
            <div class="flex_1 text_over">
              {{ item.name }}
            </div>
            <div class="d_f ali_c">
              <img
                src="../assets/img/see_num.png"
                alt=""
              >
              <span>{{ item.playNumber }}</span>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
  export default {
    name: "VideoAppreciation",
    data() {
      return {
        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        params:{
          pageIndex:1,
          pageSize:10,
          data:{
            dataSourceType:1,
            videoType:3,
          }
        },
      }
    },
    created(){
      this.listLoad();
    },
    methods: {
      listLoad(){

        this.loading = true;
        this.$api.getVideoList(this.params).then(res => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listLoad();
      },
      onLoad(){
        let me = this;
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listLoad();
      },
    }
  }
</script>

<style scoped lang="scss">
  .list_item_va{
    .li_con{
      .d_f{
        img{
          /*height: 22px;*/
          width: 26px;
          margin-right: 12px;
        }
        font-size: 24px;
        font-weight: 500;
        color: #3E3E3E;
      }
      font-size: 34px;
      font-weight: bold;
      color: #3E3E3E;
      padding: 0 30px;
      height: 83px;
    }
    .van-image{
      height: 367px;
    }
    overflow: hidden;
    background: #FFFFFF;
    border: 1PX solid #FFFFFF;
    border-radius: 10px;
    margin-top: 20px;
  }
  .va_tab{
    .tab{
      &.ac{
        font-size: 32px;
        font-weight: bold;
        color: #FFFFFF;
        background: #4C90F1;
        border: none;
      }
      box-sizing: border-box;
      margin-right: 62px;
      width: 108px;
      height: 54px;
      border: 1PX solid #6E6E6E;
      border-radius: 27px;
      text-align: center;
      line-height: 54px;
    }
    font-size: 28px;
    font-weight: bold;
    color: #3E3E3E;
  }
  .va{
    box-sizing: border-box;
    padding: 110px 25px 25px;
    height: 100vh;
    background-color: #f5f5f5;
  }

</style>
